import {makeStyles} from '@material-ui/core'

const useStyles = makeStyles(theme => ({
  root: {
    width: 250,
    float: 'right',
    padding: theme.spacing(1, 1.5),
  },
  input: {
    width: 42,
  },
}))

export default useStyles
